"use client";

import useTranslate from "@app/_hooks/useTranslate";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import Badge from "@app/_components/Badge/Badge";
import CartIcon from "@app/_icons/CartIcon/CartIcon";
import { viewCartEvent } from "@features/tracking/gtm/viewCartEvent";
import { Button } from "@ui/button";
import { Dialog, DialogTrigger } from "@ui/dialog";
import { useCartDrawer } from "../config/store";
import { useCart } from "../hooks/useCart";

const CartPanel = dynamic(() => import("./CartPanel"), { ssr: false });

export default function Cart() {
  const t = useTranslate();
  const pathname = usePathname();
  const isOpen = useCartDrawer((state) => state.isOpen);
  const open = useCartDrawer((state) => state.open);
  const close = useCartDrawer((state) => state.close);
  const { cart, quantity } = useCart();
  const [panel, setPanel] = useState(false);

  useEffect(() => {
    close();
  }, [pathname, close]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(next) => {
        if (next) {
          setPanel(true);
          open();
          if (cart) viewCartEvent(cart);
          return;
        }
        close();
      }}
    >
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="auto"
          data-testid="cart-icon-button"
          title={t("yourCart")}
          aria-label={t("yourCart")}
        >
          <Badge badgeContent={quantity}>
            <CartIcon className="size-5" />
          </Badge>
        </Button>
      </DialogTrigger>
      {panel ? <CartPanel /> : null}
    </Dialog>
  );
}
